import type { IntegrationPrepareResult } from '../../../models/IntegrationRun';
import type { Flow, FlowStep } from '@/pages/TechChecks/models';

const INTEGRATION_HEADERS = {
  Authorization: 'Bearer {{accessToken}}',
  'x-api-key': '{{apiKey}}',
  'x-api-secret': '{{apiSecret}}',
};

const step = (
  id: string,
  name: string,
  method: FlowStep['method'],
  path: string,
  options: Partial<FlowStep> = {}
): FlowStep => ({
  id,
  name,
  method,
  path,
  headers: INTEGRATION_HEADERS,
  bodyMode: 'none',
  body: '',
  fields: [],
  captures: [],
  expectStatus: '',
  enabled: true,
  ...options,
});

export const buildSmokeTestFlow = (
  prepare: IntegrationPrepareResult,
  testApi: string
): Flow => {
  const reference = `SHIPPING-TEST-${Date.now()}`;
  const shippingBody = JSON.stringify(
    { ...prepare.minimalIngestExample.createShipping.body, commerceShippingNumber: '{{reference}}' },
    null,
    2
  );

  return {
    id: 'integration-smoke-tests',
    name: 'Pruebas de la integración en test',
    description: 'Login, configuración, alta, duplicado, historial y cancelación en test',
    variables: {
      testApi,
      reference,
      loginUrl: prepare.integrationUser.loginUrl,
      username: prepare.integrationUser.email,
      password: prepare.minimalIngestExample.login.body.password,
      apiKey: prepare.credentials.apiKey,
      apiSecret: prepare.credentials.apiSecret,
      commerceCode: prepare.commerce.commerceCode,
      operatorCode: prepare.logisticOperator.logisticOperatorCode,
    },
    links: [],
    steps: [
      step('login', 'Login del usuario de integración', 'POST', '{{loginUrl}}', {
        headers: {},
        bodyMode: 'json',
        body: '{ "username": "{{username}}", "password": "{{password}}" }',
        captures: [{ name: 'accessToken', path: 'accessToken' }],
      }),
      step(
        'config',
        'Consultar configuración',
        'GET',
        '{{testApi}}/integration/config?commerceCode={{commerceCode}}&logisticOperatorCode={{operatorCode}}'
      ),
      step('create', 'Crear envío de prueba', 'POST', '{{testApi}}/integration/shipping', {
        bodyMode: 'json',
        body: shippingBody,
        expectStatus: '200,201',
      }),
      step('duplicate', 'Reenviar el mismo pedido (no duplica)', 'POST', '{{testApi}}/integration/shipping', {
        bodyMode: 'json',
        body: shippingBody,
        expectStatus: '200,201',
      }),
      step(
        'history',
        'Consultar historial',
        'GET',
        '{{testApi}}/integration/shipping/{{reference}}/historial'
      ),
      step('cancel', 'Cancelar el envío de prueba', 'POST', '{{testApi}}/integration/shipping/cancel', {
        bodyMode: 'json',
        body: '{ "externalNumber": "{{reference}}" }',
      }),
    ],
  };
};
